<template>
    <div class="main-feed pt-10 ml-5 mr-5" v-bind:style="{'zoom': '80%'}">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate color="orange"
                                 :size="70" :width="7"></v-progress-circular>
        </v-overlay>
        <div>
            <v-row>
                <v-alert v-if="errorMessage" width="100%" class="mr-5 ml-5" v-model="isError" dismissible type="error"> {{ errorMessage }}</v-alert>
            </v-row>
            <v-row>
                <v-col cols="5">
                    <v-card >
                        <v-card-title>
                            {{title}}

                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="4">       
                                <AdminKennelSearchDialog
                                    v-bind:kennelId.sync="kennelInfo.kennelId"
                                    :isEditMode="true"
                                    :showOwners="true"
                                    :hideSearch="false"
                                    />                             
                                </v-col>
                                <v-col cols="4">
                                    <v-select
                                        label="Program"
                                        dense outlined clearable
                                        :items="['HOF', 'HOFX', 'SKE']"
                                        v-model="selectedProgram" />
                                </v-col>
                                <v-spacer />
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-col>
                <v-col cols="7">
                    <v-card>
                        <v-card-title>
                            <v-text-field v-model="search"
                                          append-icon="mdi-magnify"
                                          label="Search"
                                          class="ml-1"
                                          single-line
                                          hide-details
                                          clearable>
                            </v-text-field>
                            <v-btn outlined color="primary"
                                   v-on:click="csvExport(1)">
                                <font-awesome-icon icon="file-download" size="lg" />
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                                :headers="hofCertificatesHeaders"
                                :items="filteredSourceCertificates"
                                :search="search"
                                style="font-size:9pt"
                                dense
                                show-group-by
                                hide-default-footer
                                :items-per-page="-1"
                                :height="'93vh'"
                                fixed-header>
                                <template v-slot:item.dogId="{ item }">
                                    <router-link :to="`/admin/dogs/${encodeURIComponent(item.dogId.trim())}`" target="_blank">
                                    {{ item.dogId }} 
                                    </router-link>
                                    <br/> {{ item.dogName }}                                    
                                </template>
                                <template v-slot:item.showDate="{ item }">
                                    <localized-date :date="item.showDate" />
                                </template>
                                <template v-slot:item.generatedAt="{ item }">
                                    <localized-date v-if="item.generatedAt" :date="instantToLocalDate(item.generatedAt)" />
                                </template>
                                <template v-slot:item.title="{ item }">
                                    <v-chip small pill :color="getTitleColor(item.title, item.title)" dark>
                                        {{ item.title }}
                                    </v-chip>
                                </template>
                            </v-data-table>                            
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import adminTitlingService from "@/services/admin/titlingService";
import { UserInfo } from "@/types/User";
import { debounce } from "throttle-debounce";
import { MetaNames } from "@/constants";
import AdminKennelSearchDialog from "@/components/Admin/AdminKennelSearchDialog.vue";
import { instantToLocalDate } from "@/helpers/date-utils";

export default Vue.extend({
    name: "TitlingKennelReview",
    props: {
        program: String,
        propsKennelId: String
    },
    components: {
        AdminKennelSearchDialog
    },
    data: function () {
        return {
            title: MetaNames.AdminTitlingKennelReview,
            selectedProgram: this.$props.program ?? 'HOF',
            search: '',
            kennelInfo: { kennelId: this.$props.propsKennelId ?? null } as any,
            sourceCertificates: [] as any[],                
            filteredSourceCertificates: [] as any[],
            hofCertificatesHeaders: [
                { text: "Dog", align: "left", value: "dogId" },
                { text: "Title", align: "left", value: "title" },
                { text: "Show Date", align: "left", value: "showDate" },
                { text: "Generated On", align: "left", value: "generatedAt" },
                { text: "Certificates", align: "left", value: "id", groupable: false },
            ],
            colors: [
                "#e51c23", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#5677fc", "#03a9f4", "#00bcd4",
                "#009688", "#259b24", "#8bc34a", "#afb42b", "#ff9800", "#ff5722", "#795548", "#607d8b",
            ],
            errorMessage: '',
            resultsSelectedForTitlePath: [] as any[],
            isLoading: false,
            loadRequestId: 0,
            loadSelectedReviewDebounced: null as any,
        };
    },        
    created() {
        this.loadSelectedReviewDebounced = debounce(1500, () => this.loadSelectedReview());
        if(this.$props.propsKennelId){
            if(this.$props.program){
                this.loadTitlesSelect(this.$props.program);
                } else {
                this.loadTitlesSelect('HOF');
            }
        }
    },
    beforeDestroy() {
        this.loadSelectedReviewDebounced?.cancel();
    },
    methods: {
        instantToLocalDate,
        row_classes(item: any) {
            return '';
            
        },
        getTitleColor(titleName: string, titleId: number) {
            const text = `123${titleName}123`;//`${titleId}${titleName}${titleId}`
            var hash = 0;
            if (text.length === 0) return hash;
            for (var i = 0; i < text.length; i++) {
                hash = text.charCodeAt(i) + ((hash << 3) - hash);
                hash = hash & hash;
            }
            hash = ((hash % this.colors.length) + this.colors.length) % this.colors.length;
            return this.colors[hash];
        },
        loadtitles: function (selectedProgram: string) {
            if(!selectedProgram)
                return;
            const kennelId = this.kennelInfo.kennelId;
            if(!kennelId)
                return;
            this.selectedProgram = selectedProgram;
            const requestId = ++this.loadRequestId;
            this.sourceCertificates = [];
            this.filteredSourceCertificates = [];
            this.filteredSourceCertificates = [];
            var calculatingCerts = true;
            var loadingResults = true;
            var loadingCerts = true;
            this.isLoading = true;
            
            adminTitlingService
                    .getSourceCerticatesForAKennel(kennelId, this.selectedProgram)
                    .then((res: any) => {
                        if (requestId !== this.loadRequestId
                            || kennelId !== this.kennelInfo.kennelId
                            || selectedProgram !== this.selectedProgram) return;
                        
                        this.filteredSourceCertificates = [];
                        this.sourceCertificates = res;
                        this.filteredSourceCertificates = res;
                        loadingResults = false;
                        // if (!calculatingCerts && !loadingResults && !loadingCerts) {
                             this.isLoading = false;
                        // }
                    })
                    .catch((e: any) => {
                        if (requestId !== this.loadRequestId
                            || kennelId !== this.kennelInfo.kennelId
                            || selectedProgram !== this.selectedProgram) return;
                        this.isLoading = false;
                        this.$handleError(e);
                    });
        },
        loadTitlesSelect(titleType: any) {
            this.loadtitles(titleType);                   
        },
        clearCertificates() {
            this.loadRequestId++;
            this.sourceCertificates = [];
            this.filteredSourceCertificates = [];
            this.isLoading = false;
        },
        loadSelectedReview() {
            if (this.kennelInfo?.kennelId && this.selectedProgram) {
                this.$navigate({ path: `/admin/titling/kennel/review/${this.selectedProgram}?kennelId=${encodeURIComponent(this.kennelInfo.kennelId.trim())}` });
                this.loadTitlesSelect(this.selectedProgram);
            }
        },
        csvExport: function (type: number) {
            var filename = this.kennelInfo.kennelId?.trim() + "_" + this.selectedProgram + "_certs.csv";
            var content = this.sourceCertificates;
            const keys = Object.keys(content[0]);
            const commaSeparatedString = [keys.join(","), content.map(row => keys.map(key => row[key]).join(",")).join("\n")].join("\n")
            const csvBlob = new Blob([commaSeparatedString])
            var link = document.createElement("a");
            var url = URL.createObjectURL(csvBlob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    
    },

    watch: {
        propsKennelId: function(newValue, oldValue) {
            if (newValue === oldValue || newValue === this.kennelInfo.kennelId) return;
            this.kennelInfo.kennelId = newValue ?? null;
        },
        program: function(newValue, oldValue) {
            if (newValue === oldValue || newValue === this.selectedProgram) return;
            this.selectedProgram = newValue ?? 'HOF';
        },
        "kennelInfo.kennelId": function(newValue, oldValue) {
            if (newValue === oldValue) return;
            this.clearCertificates();
            if (!newValue) {
                const path = this.selectedProgram
                    ? `/admin/titling/kennel/review/${this.selectedProgram}`
                    : '/admin/titling/kennel/review';
                this.$navigate({ path });
                return;
            }
            this.loadSelectedReviewDebounced();
        },
        selectedProgram: function(newValue, oldValue) {
            if (newValue === oldValue) return;
            this.clearCertificates();
            if (!newValue) {
                this.$navigate({
                    path: '/admin/titling/kennel/review',
                    query: this.kennelInfo?.kennelId ? { kennelId: this.kennelInfo.kennelId } : undefined,
                });
                return;
            }
            this.loadSelectedReviewDebounced();
        },
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
    },
});
</script>
